<template>
    <vs-card>
        <div
            style="cursor: pointer"
            class="flex back-div mb-5"
            @click="back"
            >
            <feather-icon class="cursor-pointer" icon="ArrowLeftIcon" />
            <span>{{ $t("return_back") }}</span>
        </div>
        <profile-info/>
        <vs-row>
            <vs-col vs-w="12">
                <vs-row>
                    <vs-col vs-lg="12" class="p-1">
                        <div>
                            <h6 class="ml-1 required" style="font-size: 12px;">
                                {{$t('study_plan')}}
                            </h6>
                            <Select
                                class="mt-2"
                                v-model="values['study_plan']"
                                noOptions="print_text_adn_biin"
                                name="study_plan"
                                noResult="not_search_result"
                                apiType="my_study_plans"
                                :max-height="170"
                                apiPath="employment/"
                                :placeholder="`${ $t('choose_option') }`"
                                v-validate="'required'"
                                trackBy="uid"
                                deselectLabel=""
                                :customLabel="study_plan_custom_label"
                                @input='selectedFun($event)'
                            />
                        </div>
                        <span class="text-danger w-full text-sm" v-show="errors.has(`study_plan`)">
                            {{ $t("validation_required") }}
                        </span>
                    </vs-col>
                    <vs-col vs-lg="12" class="p-1">
                        <div>
                            <h6 class="ml-1 required" style="font-size: 12px;">
                                {{$t('direction_of_employment')}}
                            </h6>
                            <Select
                                class="mt-2"
                                v-model="values['direction_of_employment']"
                                noOptions="print_text_adn_biin"
                                name="direction_of_employment"
                                noResult="not_search_result"
                                apiType="direction_employment"
                                :max-height="170"
                                apiPath="employment/"
                                :placeholder="`${ $t('choose_option') }`"
                                trackBy="uid"
                                deselectLabel=""
                                :customLabel="name_custom_label"
                                @input='selectedFun($event)'
                                v-validate="'required'"
                            />
                        </div>
                        <span class="text-danger w-full text-sm" v-show="errors.has(`direction_of_employment`)">
                            {{ $t("validation_required") }}
                        </span>
                    </vs-col>
                    <vs-col vs-lg="12" class="p-1">
                        <div>
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('vacancy')}}
                            </h6>
                            <Select
                                class="mt-2"
                                v-model="values['vacancy']"
                                noOptions="print_text_adn_biin"
                                name="vacancy"
                                noResult="not_search_result"
                                apiType="vacancies"
                                :max-height="170"
                                apiPath="employment/"
                                :placeholder="`${ $t('choose_option') }`"
                                trackBy="uid"
                                deselectLabel=""
                                :customLabel="name_custom_label"
                                @input='selectedFun($event)'
                            />
                        </div>
                    </vs-col>
                    <vs-col vs-lg="12" class="p-1">
                        <div>
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('future_plans')}}
                            </h6>
                            <Select
                                class="mt-2"
                                v-model="values['future_plans']"
                                noOptions="print_text_adn_biin"
                                name="future_plans"
                                noResult="not_search_result"
                                apiType="future_plans"
                                :max-height="170"
                                apiPath="employment/"
                                :placeholder="`${ $t('choose_option') }`"
                                trackBy="uid"
                                deselectLabel=""
                                :customLabel="name_custom_label"
                                @input='selectedFun($event)'
                            />
                        </div>
                    </vs-col>
                    <vs-col vs-lg="12" vs-sm="12" class="p-1" >
                        <div>
                            <h6 class="ml-1 required" style="font-size: 12px;">
                                {{$t('region_of_future_employment')}}
                            </h6>
                            <vs-input name="moving_location" v-validate="'required'" class="mt-2" style="width: 100%;"  v-model="values['moving_location']" />
                            <span class="text-danger w-full text-sm" v-show="errors.has(`moving_location`)">
                                {{ $t("validation_required") }}
                            </span>
                        </div>

                    </vs-col>
                    <vs-col vs-lg="12" vs-sm="12" class="p-1">
                        <div>
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('additional_information')}}
                            </h6>
                            <vs-textarea class="mt-2" v-model="values['additional_information']" />
                        </div>
                    </vs-col>
                    <vs-col vs-w="12" class="px-1">
                        <div class="flex items-center " style="width: fit-content;">
                            <input type="checkbox" v-model="values['employed_by_spec']">
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('employed_by_spec')}}
                            </h6>
                        </div>
                        <div class="flex items-center mt-2" style="width: fit-content;">
                            <input type="checkbox" v-model="values['work_for_last_six_months']">
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('work_for_last_six_months')}}
                            </h6>
                        </div>
                        <div class="flex items-center mt-2" style="width: fit-content;">
                            <input type="checkbox" v-model="values['work_in_home']">
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('work_in_home')}}
                            </h6>
                        </div>
                        <div class="flex items-center mt-2" style="width: fit-content;">
                            <input type="checkbox" v-model="values['recognized_as_unemployed']">
                            <h6 class="ml-1" style="font-size: 12px;">
                                {{$t('recognized_as_unemployed')}}
                            </h6>
                        </div>
                    </vs-col>
                    <div style="width: 100%; padding:20px 0px 30px 0px">
                        <span class="text-base font-medium ">
                            {{ $t("upload_the_required_documents") }}
                        </span>
                        <vs-upload
                            :action="'common/upload/'"
                            @on-success="setImageGalery"
                            @prev-delete="removeFileGalery"
                            :max-size="32"
                            automatic
                            multiple
                            :text="$t('select_a_file')"
                            :fileName="'path'"
                        />
                    </div>
                    <div class="submit-buttons mob_card pt-1 mt-2">
                        <vx-tooltip :text="$t('save_validate')" position="right" delay=".3s">
                        <vs-button
                            ref="loadableButton"
                            id="btn-save-loading"
                            icon-pack="feather"
                            icon="icon-save"
                            @click="createQUE()"
                        />
                        </vx-tooltip>
                    </div>


                </vs-row>
            </vs-col>

        </vs-row>
    </vs-card>
</template>

<script>
import ProfileInfo from './ProfileInfo'
import Select from './Select'
import { mapActions, mapMutations } from "vuex";
export default {
    name: "CreateView",
    components:{
        ProfileInfo,
        Select,
    },
    data() {
        return {
            values:{
                study_plan: null,
                direction_of_employment: null,
                vacancy: null,
                future_plans: null,
                moving_location: null,
                additional_information: null,
                employed_by_spec: false,
                work_for_last_six_months: false,
                work_in_home: false,
                recognized_as_unemployed: false,
                reference: null,
            },
            files: [],
            uploadArray: [],
        }
    },
    create() {
        this.dgdg()
    },
    methods:{
        selectedFun(val){
            this.values[`${ val.name }`] = val.select
        },
        study_plan_custom_label(item) {
            return item ?`${ item.number } `: 'Без наименований'
        },
        name_custom_label(item) {
            return item ?`${ item.name } `: 'Без наименований'
        },
        setImageGalery(response) {
            this.uploadArray = []
            response.forEach((item) => {
                this.uploadArray.push(item.uid)
            });
        },
        back() {
            this.$router.push({path:"employment-my-questionnaires"})
        },
        async dgdg(){
            let files_upload = [this.data]
            this.files = files_upload.map(
                ({file})=>{
                    return{...file, firstFiles: true,response: file}
                }
            )
        },
        async removeFileGalery({ file, done }) {
            this.files = await this.files.filter(
                (item) => {item.uid !== file.uid}
            );
            this.uploadArray = this.uploadArray.filter(
                (item) => {return item !== file.response.uid}
            )
            done();
        },
        async createQUE(){
            this.$validator.validateAll().then(async result => {
                if(result) {
                    this.$vs.loading();
                    await this.$http.post("employment/new_employed_questionnaire/create_employed/", {data:this.values,upload:this.uploadArray})
                    this.$router.push({name:"my_questionnaires"})
                    this.$vs.loading.close()

                    this.$vs.notify({
                        text: this.$t("questionnaire_created"),
                        color: "success",
                    });

                } else {
                    this.$vs.notify({
                        text: this.$t("validation_requireds"),
                        color: "danger",
                    });
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.required {
    &::after {
        content: "*";
        color: rgba(var(--vs-danger), 1);
        display: inline-block;
        margin-left: 2px;
    }
}
.back-div {
    display: flex;
    align-items: center;
}
</style>
